import React, {forwardRef} from 'react';
import ModalTemplate from "../../Wrappers/ModalTemplate";
import FormInput from "../../Atoms/Templates/FormInput";
import Select from "../../Atoms/Forms/Select";
import TextArea from "../../Atoms/Forms/TextArea";

const SubsidiaryModal = forwardRef((props, ref) => {
  return (
    <ModalTemplate
      ref={ref}
    >
      <h3 className="s-center s-mb-24px">Nueva sucursal</h3>
      <form
        action="#"
        className="s-mb-0 ed-grid rows-gap form-grid"
      >
        <div className="ed-grid m-grid-2 rows-gap">
          <FormInput isRequired
            label="Nombre"
            placeholder="Discord sucursal"/>
          <FormInput label="Teléfono"
            placeholder="123 456 7890"/>
        </div>

        <FormInput isRequired
          label="Dirección"
          placeholder="Calle falsa #123, Springfield"
        />

        <Select label="Caja de compensación familiar"
          name="#"
          placeholder>
          <option value="#">Hola</option>
        </Select>

        <TextArea label="Descripión"
          placeholder="¿Qué te gustaría decir de esta sucursal?"/>
        <div className="buttons-container">
          <button className="button cancel">Cancelar</button>
          <button className="button"
            disabled>Crear sucursal
          </button>
        </div>
      </form>
    </ModalTemplate>
  );
})

export default SubsidiaryModal;
